export default __webpack_public_path__ + "static/media/chip_10.2336c76d.svg";